import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import {PALETTE} from '../styles/paletteV3'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'





const StyledEmailLink = styled('a')({
  color: PALETTE.SKY_500
})

const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationErrorExpired = (props) => {
  const {verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationErrorExpired_verifiedInvitation on VerifiedInvitationPayload {
        teamName
        inviterName
        inviterEmail
      }
    `,
    verifiedInvitationRef
  )
  const {teamName, inviterName, inviterEmail} = verifiedInvitation
  useDocumentTitle(`Token Expired | Team Invitation`, 'Team Invitation')
  return (
    _jsxs(InviteDialog, { children: [
      _jsx(DialogTitle, { children: "Invitation Expired" })
      , _jsxs(DialogContent, { children: [
        _jsxs(InvitationDialogCopy, { children: ["The invitation to "
             , _jsx(TeamName, { children: teamName}), " has expired."
        ]})
        , _jsxs(InvitationDialogCopy, { children: ["Reach out to "
             , inviterName, " at" , ' '
          , _jsx(StyledEmailLink, { href: `mailto:${inviterEmail}`, title: `Email ${inviterEmail}`, children: 
            inviterEmail
          })
        ]})
        , _jsx(InvitationDialogCopy, { children: "to request a new one"    })
      ]})
    ]})
  )
}

export default TeamInvitationErrorExpired
